import wx from "weixin-js-sdk";
import { Toast } from "vant";
//var appid = "wx36313b15f74872cc"; //孝爱天下
//var appid = "wx9c6a2b8e9d1ead27"; //孝恩天堂
//var appid = "wxe049fa15dea38400"; //孝恩天堂
var appid="wxd16789b4b4c2f0fc"; //孝恩天堂

function Getauthorize(code, that, success) {
  var openid = sessionStorage.getItem("OpenId");
  console.log(openid);
  if (openid != null) {
    console.log("openid：" + openid);
    //   that.$store.dispatch({
    //     type: 'GetMemberIndex',
    //   })
    if (typeof success === "function") {
      // console.log("success")
      success();
    }
  } else {
    //var code = this.$route.query.code;
    if (code == undefined) {
      var url = encodeURIComponent(window.location.href);
      console.log(url);
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        appid +
        "&redirect_uri=" +
        url +
        "&response_type=code&scope=snsapi_userinfo&connect_redirect=1&state=#wechat_redirect";
    } else {
      console.log(code);
      that.$store
        .dispatch({
          type: "GetOpenId",
          code: code,
        })
        .then((res) => {
          //console.log(res);
          if (res.openid != null) {
            sessionStorage.setItem("OpenId", res.openid);
          }
          if (typeof success === "function") {
            // console.log("success")
            success();
          }
        });
    }
  }
}

function GetJssdkConfig(that) {
  // alert(location.href.split('#')[0])
  that.$store
    .dispatch({
      type: "GetJssdkConfig",
      url: encodeURIComponent(location.href.split("#")[0]),
    })
    .then((res) => {
      //console.log("GetJssdkConfig")
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appid, // 必填，公众号的唯一标识
        timestamp: res.Timestamp, // 必填，生成签名的时间戳
        nonceStr: res.NonceStr, // 必填，生成签名的随机串
        signature: res.Signature, // 必填，签名
        jsApiList: [
          "chooseWXPay",
          "scanQRCode",
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "onMenuShareQZone",
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareWeibo",
        ], // 必填，需要使用的JS接口列表
      });
      if (res.Signature != null) {
        sessionStorage.setItem("JssdkConfig", true);
      }
    });
}

function onMenuShareAppMessage(title, desc, imgUrl, pathname) {
  // console.log(location.href.split('#')[0]);
  // var defaultLogo = "http://apib.zhuniangjia.com/Resource/Command/images/default.jpg";
  // wx.onMenuShareAppMessage({
  //     title: title, // 分享标题
  //     desc: desc, // 分享描述
  //     link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //     imgUrl: defaultLogo, // 分享图标
  //     type: '', // 分享类型,music、video或link，不填默认为link
  //     dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
  //     success: function () {
  //         // 用户确认分享后执行的回调函数
  //     },
  //     cancel: function () {
  //         // 用户取消分享后执行的回调函数
  //     }
  // });
  var link = location.href;
  if (pathname) {
    link = location.origin + "/" + pathname;
  }
  wx.ready(function() {
    //需在用户可能点击分享按钮前就先调用
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    wx.updateAppMessageShareData({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function() {
        // 设置成功
      },
    });

    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    wx.updateTimelineShareData({
      title: title, // 分享标题
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function() {
        // 设置成功
      },
    });
    // 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
    wx.onMenuShareWeibo({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgUrl, // 分享图标
      success: function() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function() {
        // 用户取消分享后执行的回调函数
      },
    });
  });
}

function weiXinPay(data, s_callback, e_callback) {
  if (typeof WeixinJSBridge == "undefined") {
    //微信浏览器内置对象。参考微信官方文档
    if (document.addEventListener) {
      document.addEventListener(
        "WeixinJSBridgeReady",
        onBridgeReady(data, s_callback, e_callback),
        false
      );
    } else if (document.attachEvent) {
      document.attachEvent(
        "WeixinJSBridgeReady",
        onBridgeReady(data, s_callback, e_callback)
      );
      document.attachEvent(
        "onWeixinJSBridgeReady",
        onBridgeReady(data, s_callback, e_callback)
      );
    }
  } else {
    onBridgeReady(data, s_callback, e_callback);
  }
}

function onBridgeReady(data, s_callback, e_callback) {
  WeixinJSBridge.invoke(
    "getBrandWCPayRequest",
    {
      appId: data.appId, //公众号名称，由商户传入
      timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
      nonceStr: data.nonceStr, //随机串
      package: data.package,
      signType: data.signType, //微信签名方式：
      paySign: data.paySign, //微信签名
    },
    function(res) {
      console.log(res);
      // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        //alert("支付成功！");
        Toast("支付成功！");
        if (typeof s_callback === "function") {
          s_callback();
        }
      } else {
        //Toast('支付失败,错误信息:' + res.errMsg);
        Toast("支付失败，用户已取消或者内部出错！");
        if (typeof e_callback === "function") {
          e_callback();
        }
      }
    }
  );
}

function IsWeiXin() {
  var _isWeiXin = false;
  var broser = window.navigator.userAgent.toLowerCase();
  console.log(broser);
  //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
  if (broser.match(/MicroMessenger/i) == "micromessenger") {
    console.log("微信浏览器");
    _isWeiXin = true;
  }
  return _isWeiXin;
}

function AutoWeixinAuthorize(that) {
  console.log("AutoWeixinAuthorize");
  var _isWeiXin = IsWeiXin();
  if (_isWeiXin) {
    console.log("微信浏览器进入");
    var openid = sessionStorage.getItem("OpenId");
    if (openid == null) {
      var code = that.$route.query.code;
      Getauthorize(code, that, function() {
        GetJssdkConfig(that);
      });
    }
  }
}

export default {
  weixinAuthorize: function(code, that, success) {
    Getauthorize(code, that, success);
  },
  GetJssdkConfig: function(that) {
    GetJssdkConfig(that);
  },
  ShareWeiXinAppMessage: function(title, desc, imgUrl, pathname) {
    onMenuShareAppMessage(title, desc, imgUrl, pathname);
  },
  showMsg: function(that, msg, type, success) {
    ShowMsg(that, msg, type, success);
  },
  weiXinPay: function(data, s_callback, e_callback) {
    weiXinPay(data, s_callback, e_callback);
  },
  IsWeiXin: function() {
    return IsWeiXin();
  },
  AutoWeixinAuthorize: function(that) {
    AutoWeixinAuthorize(that);
  },
};
